
export interface CartItem {
  id: number;
  sessionId: string;
  barId: string;
  drinkId: number;
  drinkName: string;
  category?: string;
  quantity: number;
  unitPrice: number;
  subtotal: number;
  specialInstructions?: string | null;
  createdAt?: string;
  updatedAt?: string;
}
